/**
 * Recursively removes every `__typename` key from a value.
 *
 * Objects read from the Apollo cache carry `__typename`, but GraphQL input types reject it, so any
 * cached object that is fed back into a mutation input must have it stripped first. Arrays and
 * nested objects are handled recursively; primitives are returned unchanged.
 */
export function stripTypename<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((item) => stripTypename(item)) as unknown as T;
  }

  if (value != null && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([key]) => key !== '__typename')
      .map(([key, val]) => [key, stripTypename(val)] as const);
    return Object.fromEntries(entries) as T;
  }

  return value;
}
